import { LandingPageConfig } from 'rangeConfig/@types';
import billyBgImage from '../../views/LandingPage/images/billy_landing_bg.jpg';
import billyOpenDesignImg from '../../views/LandingPage/images/billy_landing_open_design.jpg';
import designFromScratch from '../../views/LandingPage/images/designFromScratch.jpg';
import billyInspirationImg from '../../views/LandingPage/images/billyInspirationImage.png';
import billyGalleryConfig from './billyGalleryConfig';

const billyLandingPageConfig: LandingPageConfig = {
  rangeDesign: {
    backgroundImgUrl: billyBgImage,
    titleTextColor: '#FFFFFF'
  },
  designFromScratch: {
    backgroundColor: '#EAD8DD',
    backgroundImgUrl: designFromScratch
  },
  openDesign: {
    backgroundColor: '#F5F5F5',
    backgroundImgUrl: billyOpenDesignImg
  },
  browseInspiration: {
    backgroundColor: '#F2BE8A',
    backgroundImgUrl: billyInspirationImg,
    galleryConfig: billyGalleryConfig
  }
};

export default billyLandingPageConfig;
